export interface ProjectServiceType {
  id?: number;
  name?: string;
}
// to single object maping
export const mapProjectServiceType = (data: any): ProjectServiceType => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: ProjectServiceType = {
    id: data.id,
    name: data.name,
  };
  return res;
};

// maping list objects
export const mapProjectServiceTypes = (data: any[]): ProjectServiceType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapProjectServiceType);
};
